import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import dataFetcher from 'Parts/chore/dataFetcher';

import GeneralSettingsPage from './GeneralSettingsPage';

const mapStateToProps = state => ({
  locale: state.session.language
});

export default compose(
  connect(mapStateToProps),
  withRouter,
  dataFetcher
)(GeneralSettingsPage);
